import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PostCard from "../Home/PostCard";
import "../../styles/invitation.css";
import { Chip, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";

const Invitations = ({ data, closeForm, setCloseForm, setPost, post }) => {
  const handleCloseForm = (e) => {
    e.preventDefault();
    setCloseForm(!closeForm);
  };

  const deleteInvitation = () => {};

  const editForm = (item) => {
    setPost(item);
    setCloseForm(!closeForm);
  };

  const deleteRequest = (invitationId, requestId) => {
    axios.delete(
      "api/invitation/request",
      {
        invitationId,
        requestId,
      },
      {
        headers: {
          "x-auth-token": localStorage.getItem("user"),
        },
      }
    );
  };

  const addCollaborators = (invitationId, userId) => {
    axios.put(
      "api/invitation/",
      {
        invitationId,
        userId,
      },
      {
        headers: {
          "x-auth-token": localStorage.getItem("user"),
        },
      }
    );
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "0 50px",
        flexDirection: "column",
      }}
    >
      {data.map((item) => (
        // <PostCard post={item} />
        <Card key={item._id} className="invitation-card">
          <CardContent>
            <Typography style={{ fontSize: 25 }}>
              {item.invitationId?.title}
            </Typography>
            <Typography style={{ fontSize: 25 }}>{item.title}</Typography>
            <Typography style={{ fontSize: 16 }}>
              About: {item.about} {item.invitationId?.about}
            </Typography>
            <Typography style={{ fontSize: 16 }}>
              Tech Stack: {item.techStack} {item.invitationId?.techStack}
            </Typography>
            <Typography style={{ fontSize: 16 }}>
              Requirements: {item.requirements}{" "}
              {item.invitationId?.requirements}
            </Typography>
            <Typography style={{ fontSize: 16 }}>
              Reason to be selected: {item.why}
            </Typography>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <span style={{ fontSize: 18, paddingRight: "5px" }}>
                Skills:{" "}
              </span>
              <div style={{ display: "flex", alignItems: "center" }}>
                {item.invitationId?.tags.map((skill) => (
                  <Chip
                    key={skill._id}
                    component="a"
                    label={skill.value}
                    className="chips small"
                  />
                ))}
              </div>
            </div>
          </CardContent>
          <CardActions style={{ display: "flex", justifyContent: "center" }}>
            <Button className="update_btn" variant="contained">
              <DeleteIcon sx={{ color: "#193244" }} />
              {item.invitationId ? (
                <span
                  className="edit_txt"
                  onClick={() => deleteRequest(item.invitationId._id, item._id)}
                >
                  Delete Request
                </span>
              ) : (
                <span
                  className="edit_txt"
                  onClick={() => deleteInvitation(item._id)}
                >
                  Delete Invitation
                </span>
              )}
            </Button>
            <Button className="update_btn" variant="contained">
              <EditIcon sx={{ color: "#193244" }} />
              {item.invitationId ? (
                ""
              ) : (
                <span className="edit_txt" onClick={() => editForm(item)}>
                  Edit Invitation
                </span>
              )}
            </Button>
            <Button
              className="update_btn"
              variant="contained"
              onClick={
                () => addCollaborators(item.invitationId._id, item.userId) // update for proper id
              }
            >
              <EditIcon sx={{ color: "#193244" }} />
              {item.invitationId ? (
                ""
              ) : (
                <span className="edit_txt">Add Collaborators</span>
              )}
            </Button>
          </CardActions>
        </Card>
      ))}
    </div>
  );
};

export default Invitations;
